
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BooksHero from './components/BooksHero';
import BooksList from './components/BooksList';

const BooksPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <BooksHero />
      <BooksList />
      <Footer />
    </div>
  );
};

export default BooksPage;
